var exports = {
  "Yt": "Product__njOtv1",
  "M4": "Product__media__VHmtFH",
};

module.exports = exports;
